import React from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="bg-brand-black text-white py-16 lg:py-24 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-155">
      <div className="max-w-7xl mx-auto" data-id="element-156">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-157">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="w-full lg:w-1/2 text-center lg:text-left" data-id="element-158">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6" data-id="element-159">
              The Solution:
              <br data-id="element-160" />
              <span className="text-brand-purple-light" data-id="element-161">
                Zenify Neck Relief™
              </span>
            </h2>
            <p className="text-lg text-gray-300 mb-8 leading-relaxed max-w-xl mx-auto lg:mx-0" data-id="element-162">
              This inflatable neck stretcher gently decompresses your spine,
              reduces pressure and allows your muscles to relax in just minutes.
            </p>
            <p className="text-yellow-400 text-sm font-semibold mb-3 flex items-center gap-1.5 justify-center lg:justify-start" data-id="element-163">
              <span data-id="element-164">⚠️</span> Limited stock available – selling fast
            </p>
            <a href="https://zenifyliving.com/cart/48194365325482:1?checkout" className="block w-full sm:w-auto text-center bg-brand-purple hover:bg-brand-purple-dark text-white font-bold text-lg py-4 px-8 rounded-full transition-all duration-300 shadow-[0_0_20px_rgba(124,58,237,0.3)] hover:shadow-[0_0_30px_rgba(124,58,237,0.5)] hover:scale-105" data-id="element-165">
              Stop Living With Pain
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="w-full lg:w-1/2 relative flex justify-center" data-id="element-166">
            <div className="absolute inset-0 bg-brand-purple rounded-full blur-[120px] opacity-40 max-w-md mx-auto" data-id="element-167"></div>
            <img src="https://cdn.magicpatterns.com/uploads/rEX3XFSdcNBN3jGrbyKC8X/producto_zen.png" alt="Zenify Neck Relief Device" className="relative z-10 w-full max-w-md h-auto rounded-2xl shadow-2xl border border-white/5" data-id="element-168" />
          </motion.div>
        </div>
      </div>
    </section>;
}